import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { ICredentialModel } from '../../types/credentials/ICredentialModel';

export interface ListCredentialModelsParams {
    targetClass: string;
}

export interface IListCredentialModelsResult extends IResult {
    credentialModels: ICredentialModel[];
}

export class ListCredentialModelsRequest extends Request<ListCredentialModelsParams, IListCredentialModelsResult> {
  constructor(params: ListCredentialModelsParams) {
    super('listCredentialModels', params);
  }
}